var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("div", { staticClass: "clearfix tab-header-panel" }, [
        _c("div", { staticClass: "btn-container" }, [
          _c("div", { staticClass: "viewAll" }, [
            _c("i", { on: { click: _vm._viewAll } }, [
              _vm._v(_vm._s(_vm.$t("viewAll"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "fillSpace" }),
          _vm._v(" "),
          _c("div", { staticClass: "btn-with-hint" }, [
            !_vm.isEngineer
              ? _c("div", { staticClass: "hints" }, [
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "termsAndConditions." +
                            _vm.regionName +
                            ".workPermit.hintForEdinburghTower",
                          [_vm.$t("workPermit.types.WORK"), 5]
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "termsAndConditions." +
                            _vm.regionName +
                            ".workPermit.hintForOthers",
                          [_vm.$t("workPermit.types.WORK"), 3]
                        )
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isEngineer
              ? _c(
                  "button",
                  {
                    staticClass: "btn--orange",
                    on: {
                      click: function () {
                        return _vm.applySAWorkPermit()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("standaloneWorkPermits.applySAWorkPermit")
                        ) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-wrapper" }, [
        _c(
          "table",
          [
            _c("thead", [
              _c(
                "tr",
                [
                  _c("th"),
                  _vm._v(" "),
                  _vm._l(_vm.itemHeaders, function (header, index) {
                    return _c(
                      "th",
                      {
                        key: index,
                        class: header.class,
                        on: {
                          click: function ($event) {
                            return _vm.sortBy(header.code)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(header.name) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("WorkPermitTableBody", {
              attrs: {
                items: _vm.items,
                showActive: _vm.showActive,
                tenancyTabIndex: _vm.tenancyTabIndex,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "applyStandaloneWPModal",
          attrs: {
            modalId: "apply-standalone-workpermits-modal",
            showCloseBtn: false,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-pure-text popup",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _vm._v("\n      " + _vm._s(_vm.$t("standaloneWorkPermits.text"))),
              _c("br"),
              _c("br"),
              _vm._v(
                _vm._s(_vm.$t("standaloneWorkPermits.applyProceedText")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { id: "confirm_no", type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.closeApplyStandaloneWPModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { id: "confirm_yes", type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.createStandaloneWp()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.confirm")))]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("SAWorkPermitTnC", {
        ref: "saWpTnCModal",
        attrs: {
          okBtnAction: "accept",
          companyName: _vm.selectedTrCompanyName,
        },
        on: { onOkClick: _vm.openApplyStandaloneWPModal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }